$(function () {
  const text = $(".marquee-text");
  const block = $(".block");
  const clone = text;

  const anim = () => {
    $(clone).clone().appendTo($(block));
    $(".block").animate(
      {
        left: "-100%"
      },
      12000,
      "linear",
      function () {
        $(".marquee-text").first().remove();
        $(block).css("left", "0");
        anim();
      }
    );
  };

  const blockList = $(".block-list");
  const list = $(".marquee-list");
  const listWidth = list.width() + parseInt($(blockList).css("gap"));
  $(list).clone().appendTo($(blockList));
  const animList = () => {
    $(list).clone().appendTo($(blockList));
    $(blockList).animate(
      {
        left: -listWidth
      },
      30000,
      "linear",
      function () {
        $(".list").first().remove();
        $(blockList).css("left", "0");
        animList();
      }
    );
  };
  anim();
  animList();
});
